import React from 'react';

export const VendorFileArchiveContext = React.createContext({});
